module.exports = __webpack_public_path__ + "img/infobox.80006aca.svg";